export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "op-eq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Est"])},
        "op-neq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["N'est pas"])},
        "op-sw": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Commence par"])},
        "op-ew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se termine par"])},
        "op-ct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contient"])},
        "op-nct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne contient pas"])},
        "op-lt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus petit que"])},
        "op-le": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus petit ou égal à"])},
        "op-gt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus grand que"])},
        "op-ge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plus grand ou égal à"])},
        "op-yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oui"])},
        "op-no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non"])},
        "subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sujet"])},
        "rule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Règle"])},
        "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantité"])},
        "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valeur"])},
        "select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionnez une option"])},
        "edit-condition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier la condition"])},
        "delete-condition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer la condition"])}
      },
      "en": {
        "op-eq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is"])},
        "op-neq": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is not"])},
        "op-sw": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Starts with"])},
        "op-ew": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ends with"])},
        "op-ct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contains"])},
        "op-nct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Does not contain"])},
        "op-lt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lesser than"])},
        "op-le": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lesser or equal to"])},
        "op-gt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greater than"])},
        "op-ge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greater or equal to"])},
        "op-yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes"])},
        "op-no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No"])},
        "subject": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
        "rule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rule"])},
        "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantity"])},
        "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
        "select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select option"])},
        "edit-condition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit condition"])},
        "delete-condition": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete condition"])}
      }
    }
  })
}
